/* Show Cutoff Time and shipping info, this component only show information */
import React from 'react'

export default () => (
  <div className="card border-0 mt-4">
    <div className="card-body">
      <span>CUTOFF TIME: 5PM (PST)</span>
      <hr/>

      <strong>SHIPPING SCHEDULE FOR 3 BUSINESS DAY ORDERS:</strong>
      <ul className="list-unstyled">
        <li>Orders received on Monday will ship Thursday.</li>
        <li>Orders received on Tuesday will ship Friday.</li>
        <li>Orders received on Wednesday will ship the following Monday.</li>
        <li>Orders received on Thursday will ship the following Tuesday.</li>
        <li>Orders received by Noon Friday will ship the following Wednesday.</li>
      </ul>

      <div className="mt-5 fw-bold">SHIPPING SCHEDULE FOR 4 OR MORE BUSINESS DAY ORDERS FOLLOW THE SAME LOGIC. </div>
    </div>
  </div>
)
